/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import React, { createRef } from 'react';
import { Row, Col, Modal, Table, Spinner, Button, Form } from 'react-bootstrap';
import { image_thumbnail } from 'shared/images/images';
import { ItemsService, LocationService } from 'shared/services';
import { dateTimeFormat, sortByList } from 'shared/modifiers';
import ToasterMessage from 'shared/toast/toast';
import { logout } from 'shared/settings/auth';
import store from 'features/store';
import { convertToMaintainData, getMaintainData, removeStateMaintainValue, wonNotWon } from 'shared/settings/stateMaintain';
import { addDataLayer, getItemUrl } from 'shared/utils/utils';

import './WonAndNotWonDatatable.scss';
import { AddAriaLabel } from 'shared/utils/AddAriaLabel';
/**


@Author Karthik

@param

@return Won and Not won html

**/

export class WonAndNotWonDatatable extends React.Component {
    constructor(props) {
        super(props);

        this.toasterMessage = createRef();
        this.page = this.props.page;
        this.maintainKey = `${wonNotWon}/${this.props.history.location.pathname}`;
        this.wonSort = [
            // { name: "Newest Sale", value: "newest-sale" },
            // { name: "Oldest Sale", value: "oldest-sale" },
            { name: "Item Title A-Z", value: "item-title-a-z" },
            { name: "Item Title Z-A", value: "item-title-z-a" },
            { name: "Location Name A-Z", value: "location-name-a-z" },
            { name: "Location Name Z-A", value: "location-name-z-a" },
            { name: "Newest - Oldest", value: "newest-sale" },
            { name: "Oldest - Newest", value: "oldest-sale" },
            { name: "Price Low - High", value: "lowest-price" },
            { name: "Price High - Low", value: "highest-price" },
        ];
        this.notWonSort = [
            // { name: "Ending First", value: "ending-first" },
            // { name: "Ending Last", value: "ending-last" },
            { name: "Item Title A-Z", value: "item-title-a-z" },
            { name: "Item Title Z-A", value: "item-title-z-a" },
            { name: "Location Name A-Z", value: "location-name-a-z" },
            { name: "Location Name Z-A", value: "location-name-z-a" },
            { name: "Newest - Oldest", value: "newest-sale" },
            { name: "Oldest - Newest", value: "oldest-sale" },
            { name: "Price Low - High", value: "lowest-price" },
            { name: "Price High - Low", value: "highest-price" },
        ];
        this.state = {
            pageLoading: true,
            itemsList: [],
            deleteList: [],
            wonAndNotWonList: [],
            bidHistory: [],
            bidHistoryModal: false,
            bidLoading: false,
            totalItems: 0,
            sort: this.page === "won" ? [{ "field": "itemclosetime", "direction": "desc" }] : [{ "field": "itemclosetime", "direction": "desc" }],
            sortByList: [],
            includeArchiveItems: false,
            itemsArchived: {},
            archiveItems: {},
            addArchiveStatus: '',
            sortByValue: "newest-sale",
            onLoad: false
        }

    }

    componentDidMount() {
        this.loadInitialData(true);
        removeStateMaintainValue([`ActiveItemIndex${this.maintainKey}`]);
    }

    componentDidUpdate() {
        if (!this.state.pageLoading && !this.state.onLoad) {
            this.setState({onLoad: true});
        }
    }

    resetArchived = () => {
        this.setState({
            archiveItems: {},
            totalItems: 0,
        })
    }

    loadInitialData = (checkPreviousData = false) => {
        const check = this.props.history.action === "POP" &&
            this.props.previousPath.component === "itemview";
        if (check && checkPreviousData && !this.props.stopStateMaintain) {
            this.getPreviousValues();
        } else {
            this.formatData(false);
        }
    }

    formatData = (append = true) => {
        if (this.page === 'won') {
            const filterList = [{ "field": "buyerid", "value": this.props.user.id, "op": "=", "join": "AND" }];
            if (!this.state.includeArchiveItems) {
                filterList.push({ "field": "archived", "value": 1, "op": "!=", "join": "AND" })
            }
            const wonData = {
                "sort": this.state.sort,
                "filter": filterList,
                "field": ["id", "bidwonstatus", "bidwonnotes", "itemid", "itemclosetime", "buyerid", "nickname", "bidwonprice", "createddate", "archived"],
                "page": append && this.state.nextList ? { "size": 48, next: this.state.nextList } : { 'size': 48 }
            };
            const wonAndNotWonList = append ? this.state.wonAndNotWonList : [];
            ItemsService.getWonItems(wonData).then(
                response => {
                    const tempList = response.data.data;
                    const pageNext = response.data.page && response.data.page.keyset && response.data.page.keyset.next ? response.data.page.keyset.next : null;
                    const count = response.data.page && response.data.page.total ? response.data.page.total :  tempList.length;
                    const items = wonAndNotWonList.concat(tempList);

                    this.setState({
                        wonAndNotWonList: items,
                        nextList: pageNext,
                        totalItems: count,
                        sortByList: JSON.parse(JSON.stringify(tempList)),
                        itemsArchived: items.reduce((acc, item) => {
                            acc[item.itemid] = !!item.archived;
                            return acc;
                        }, {})
                    });
                    if (tempList.length > 0) {
                        const filter = tempList.map(x => x.itemid);
                        const itemsData = {
                            "field": ["id", "title", "saleid", "saletitle", "displayimageurl", "thumbnailurl", "zipcode", "itemclosetime", "locationid", "locationtitle"],
                            "sort": [{ "field": "id", "direction": "desc" }],
                            "filter": [{ "field": "id", "value": [filter], "op": "IN", "join": "AND" }]
                        };
                        this.getItemsList(itemsData, append);
                    } else {
                        if (!append) {
                            this.setState({
                                itemsList: [],
                                pageLoading: false,
                                filterLoading: false,
                            }, () => {
                                this.emitData();
                            });
                        }
                    }
                }
            ).catch(error => {
                if (error?.status === 401) {
                    store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                    logout(this.props.history, false);
                } else {
                    this.setState({
                        itemsList: append ? this.state.itemsList : [],
                        pageLoading: false,
                        loaderForMore: false,
                        filterLoading: false,
                    });
                }
            });
        } else {
            const filterList = [];
            if (!this.state.includeArchiveItems) {
                filterList.push({ "field": "archived", "value": 1, "op": "!=", "join": "AND" })
            }
            const notWonData = {
                "sort": this.state.sort,
                "filter": filterList,
                "field": ["id", "itemid", "buyerid", "archived", "createddate", "itemclosetime", "nickname", "bidprice", "maxproxyprice", "bidwonprice"],
                "page": append && this.state.nextList ? { "size": 48, next: this.state.nextList } : { 'size': 48 }
            };
            const wonAndNotWonList = append ? this.state.wonAndNotWonList : [];
            ItemsService.getNotWonItems(notWonData).then(
                response => {
                    const tempList = response.data.data;
                    const pageNext = response.data.page && response.data.page.keyset && response.data.page.keyset.next ? response.data.page.keyset.next : null;
                    const count = response.data.page && response.data.page.total ? response.data.page.total : tempList.length;
                    const items = wonAndNotWonList.concat(tempList);

                    this.setState({
                        wonAndNotWonList: items,
                        nextList: pageNext,
                        totalItems: count,
                        sortByList: JSON.parse(JSON.stringify(tempList)),
                        itemsArchived: items.reduce((acc, item) => {
                            acc[item.itemid] = !!item.archived;
                            return acc;
                        }, {})
                    });
                    if (tempList.length > 0) {
                        const filter = tempList.map(x => x.itemid);
                        const itemsData = {
                            "field": ["id", "title", "saleid", "saletitle", "displayimageurl", "thumbnailurl", "zipcode", "itemclosetime", "locationid", "locationtitle"],
                            "sort": [{ "field": "id", "direction": "desc" }],
                            "filter": [{ "field": "id", "value": [filter], "op": "IN", "join": "AND" }]
                        };
                        this.getItemsList(itemsData, append);
                    } else {
                        if (!append) {
                            this.setState({
                                itemsList: [],
                                pageLoading: false,
                                filterLoading: false,
                            }, () => {
                                this.emitData();
                            });
                        }
                    }
                }
            ).catch(error => {
                if (error?.status === 401) {
                    store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                    logout(this.props.history, false);
                } else {
                    this.setState({
                        itemsList: append ? this.state.itemsList : [],
                        pageLoading: false,
                        loaderForMore: false,
                        filterLoading: false,
                    });
                }
            });
        }
    }

    getItemsList = (itemsData, append) => {
        const itemList = append ? this.state.itemsList : [];
        ItemsService.getWonandNotWonItemsList(itemsData).then(
            itemsList => {
                const temp = sortByList({ itemArray: itemsList.data.data, key: "id" }, { sortingArray: JSON.parse(JSON.stringify(this.state.sortByList)), key: "itemid" });
                this.setState({
                    itemsList: itemList.concat(temp),
                    loaderForMore: false,
                    pageLoading: false,
                    filterLoading: false,
                }, () => {
                    this.emitData();
                });
            }
        ).catch((error) => {
            this.setState({
                itemsList: [],
                pageLoading: false,
                filterLoading: false,
            }, () => {
                this.emitData();
            });
        });
    }

    emitData = (scrollPage = false) => {
        this.props.getItemsList({
            data: this.state.itemsList,
            length: this.state.itemsList ? this.state.itemsList.length : 0,
            scrollPage
        });
    }

    deleteDataEmit = () => {
        this.props.deleteItemsList({ data: this.state.deleteList, length: this.state.deleteList ? this.state.deleteList.length : 0 });
    }
    selectItems = (item) => {
        const deleteList = this.state.deleteList;
        const index = deleteList.findIndex(x => x === item.id);
        if (index !== -1) {
            deleteList.splice(index, 1);
        } else {
            deleteList.push(item.id);
        }
        this.setState({
            deleteList: deleteList
        })
    }

    selectAllCheckBox = () => {
        const itemsList = this.state.itemsList;
        const deleteList = this.state.deleteList;
        return itemsList.length === deleteList.length;
    }

    deleteEnable = () => {
        const deleteList = this.state.deleteList;
        return deleteList.length > 0;
    }

    deleteAllSelect = (event) => {
        const itemsList = this.state.itemsList;
        let deleteList = [];
        if (event.target.checked) {
            deleteList = itemsList.map(x => x.id);
        }
        this.setState({
            deleteList: deleteList
        });
    }

    getBidPrice = (item) => {
        const temp = this.state.wonAndNotWonList.filter(x => x.itemid === item.id);
        const itemDetail = temp[0];
        return itemDetail?.bidprice ? '$' + parseFloat(itemDetail.bidprice).toFixed(2) : '---';
    }

    getFinalPrice = (item) => {
        const temp = this.state.wonAndNotWonList.filter(x => x.itemid === item.id);
        const itemDetail = temp[0];
        return itemDetail?.bidwonprice ? '$' + parseFloat(itemDetail.bidwonprice).toFixed(2) : '---';
    }

    getDateAndTime = (item, type = 'Date') => {
        const temp = this.state.wonAndNotWonList.filter(x => x.itemid === item.id);
        const itemDetail = temp[0];
        const createddate = itemDetail?.itemclosetime && itemDetail?.itemclosetime !== "1970-01-01 00:00:00" ? dateTimeFormat(itemDetail.itemclosetime, type === 'Time') : '---';
        return createddate;
    }

    getNickname = (item) => {
        const temp = this.state.wonAndNotWonList.filter(x => x.itemid === item.id);
        const itemDetail = temp[0];
        const createddate = itemDetail?.nickname ? 'Won by - ' + itemDetail?.nickname : '---';
        return createddate;
    }

    bidHistoryModalToggle = () => {
        this.setState({
            bidHistoryModal: !this.state.bidHistoryModal
        })
    }

    getBidHistory = (event, item) => {
        event.stopPropagation();
        this.setState({
            bidLoading: true,
            bidHistory: [],
            bidHistoryModal: true
        }, () => {
            /* Get Bid History */
            ItemsService.getBidHistoryForWonAndNotWon(item.id).then(
                bidHistory => {
                    this.setState({
                        ...this.state,
                        bidHistory: bidHistory.data.data.bidhistory ? bidHistory.data.data.bidhistory : [],
                        bidLoading: false,
                    });
                }
            ).catch((error) => {
                // TODO: Error message handle
                this.setState({
                    ...this.state,
                    bidHistory: [],
                    bidLoading: false,
                });
            });
        });
    }

    getMoreList = () => {
        this.setState({
            loaderForMore: true
        }, () => {
            this.formatData();
        })
    }

    locationScreen = (event, item) => {
        event.stopPropagation();
        LocationService.getLocationDetails(item.locationid, { data: {} }).then(locationData => {
                const locationDetails = locationData.data.data[0];
                if(locationDetails){
                    const LocationUrl = locationDetails.locationcode ? `/estate-sales/${locationDetails.locationstatecode}/${locationDetails.locationcode}` : `/estate-sales/${locationDetails.locationstatecode}`;
                    this.props.history.push(LocationUrl);
                }
                let dataLayerData = {
                    'event': 'contact_seller',
                    'title': locationDetails.title
                }
                addDataLayer(dataLayerData);
            }
        ).catch(error => {
            this.handleError();
        });
    }

    itemViewScreen = (item, index) => {
        // const id = item?.id;
        if (!this.props.stopStateMaintain && this.state.wonAndNotWonList.length > 0) {
            if (this.props.stateMaintenance) {
                this.props.stateMaintenance();
            }
            convertToMaintainData(this.maintainKey, {
                ...this.state
            });
        }
        sessionStorage.setItem(`ActiveItemIndex${this.maintainKey}`, JSON.stringify(index));
        sessionStorage.setItem("ActivePathName", this.maintainKey);
        this.props.history.push(getItemUrl(item.saleid, item.id, item.itemseourl));
    }   

    filterChange = (event) => {
        const value = event?.target?.value;
        const filterValue = {
            "item-title-a-z": { "field": "itemtitle", "direction": "asc" },
            "item-title-z-a": { "field": "itemtitle", "direction": "desc" },
            "location-name-a-z": { "field": "locationtitle", "direction": "asc" },
            "location-name-z-a": { "field": "locationtitle", "direction": "desc" },
            "newest-sale": { "field": "itemclosetime", "direction": "desc" },
            "oldest-sale": { "field": "itemclosetime", "direction": "asc" },
            "ending-first": { "field": "createddate", "direction": "asc" },
            "ending-last": { "field": "createddate", "direction": "desc" },
            "lowest-price": { "field": "bidwonprice", "direction": "asc" },
            "highest-price": { "field": "bidwonprice", "direction": "desc" },
        };
        const sort = filterValue[value] ? [filterValue[value]] : this.state.sort;
        this.setState({
            filterLoading: true,
            sort: sort,
            sortByValue: value,
        }, () => {
            this.formatData(false);
        });
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    getPreviousValues = () => {
        try {
            const previousState = getMaintainData(this.maintainKey);
            if (previousState && Object.keys(previousState).length > 0) {
                this.setState({
                    ...previousState,
                }, () => {
                    this.emitData(true);
                });
            } else {
                this.loadInitialData(false);
            }
        } catch (e) {
            this.loadInitialData(false);
        }
    }

    toggleArchiveItems = (event, id) => {
        this.setState((prevState) => {
            const archiveItems = { ...(prevState.archiveItems) };
            if (archiveItems[id])
                delete archiveItems[id];
            else
                archiveItems[id] = true;
            return { archiveItems }
        });
        event.preventDefault();
        event.stopPropagation();
    }

    toggleIncludeArchiveItems = () => {
        this.setState({
            includeArchiveItems: !this.state.includeArchiveItems,
        });
        this.resetArchived();
        this.filterChange();
    }

    addArchive = () => {
        this.setState({
            addArchiveStatus: "REQUEST"
        }, () => {
            const payload = {
                "data": {
                    "itemIds": Object.keys(this.state.archiveItems)
                }
            };
            ItemsService.addArchive(this.page, payload).then(
                () => {
                    this.setState({
                        addArchiveStatus: "SUCCESS",
                        archiveItems: {}
                    });
                    this.filterChange();
                }
            ).catch((error) => {
                // TODO: Bugsnag
                this.toasterMessage.current.showMessage({ type: 'danger', message: error.message || 'Something went wrong while archive' });
                this.setState({
                    addArchiveStatus: "FAILURE"
                });
            });
        });
    }

    includeArchiveDom = (isButton) =>
        isButton ?
            <Button onClick={() => {
                this.setState({
                    pageLoading: true,
                });
                this.toggleIncludeArchiveItems();
            }}
                style={{ margin: '8px' }}>
                Include Archived
            </Button>
            : <div className='d-flex align-items-center include-archive-item-div'>
                <Form.Check
                    custom
                    type="checkbox"
                    id="includeArchiveItems"
                    checked={this.state.includeArchiveItems}
                    aria-label='Checked Include Archived'
                    onChange={this.toggleIncludeArchiveItems}
                />
                <div className="include-archive-item-text clickable" onClick={this.toggleIncludeArchiveItems}>Include Archived</div>
            </div>;

    countDom = (className) => <span className={className}>{this.page === 'won' ? 'Won' : 'Not Won'} - {this.state.filterLoading ? '0' : this.state.totalItems}</span>;


    render() {
        return (
            <div className="won-and-not-won-datatable-main">
                <AddAriaLabel loading={this.state.onLoad} config={[
                    {id: 'includeArchiveItems', label: 'Checked Include Archived'}
                ]}/>
                {
                    this.state.pageLoading ?
                        <div className="loader d-flex align-items-center justify-content-center h-100">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                        </div> :
                        <div className="data-list">
                            {
                                this.state.itemsList.length === 0 ?
                                    <div className="no-data-found d-flex flex-column align-items-center justify-content-center h-100">
                                        {/* <div className="text-center no-data-search-icon">
                                        <i className="fas fa-search fa-3x"></i>
                                    </div>
                                    <div className="text-center h4 text-bold">
                                        No results found
                                    </div> */}
                                        <div className="text-center text-muted h5">
                                            {/* We couldn't find what you're looking for. */}
                                            You don't have any items.
                                        </div>
                                        {!this.state.includeArchiveItems &&
                                            this.includeArchiveDom(true)}
                                    </div> : null
                            }
                            {
                                this.state.itemsList.length > 0 ?
                                    <>
                                        <div className="d-flex align-items-center justify-content-center">
                                            <ToasterMessage className="alert-handle" ref={this.toasterMessage}></ToasterMessage>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between page-details">
                                            <div className="d-flex align-items-center justify-content-between header-left w-20 gap-8">
                                                <div className="d-flex align-items-center  top-left" style={{ paddingRight: 8 }}>
                                                    <div className="text-bold">Sort by:</div>
                                                    <Form.Group className="remove-bottom" controlId="formGridState">
                                                        <Form.Control as="select" aria-label="Sort by" value={this.state.sortByValue} className="sort" onChange={(e) => {
                                                            this.resetArchived();
                                                            this.filterChange(e);
                                                        }}>
                                                            {
                                                                this.page === 'won' ?
                                                                    this.wonSort.map((sortBy, index) => <option value={sortBy.value} key={`won_${index}`}>{sortBy.name}</option>) :
                                                                    this.notWonSort.map((sortBy, index) => <option value={sortBy.value} key={`notwon_${index}`}>{sortBy.name}</option>)
                                                            }
                                                            {/* <option value="closing-soon">Closing Soon</option>
                                                        <option value="won">Won</option>
                                                        <option value="not-won">Not Won</option>
                                                        <option value="listing-closed">Listing Closed</option> */}
                                                        </Form.Control>
                                                    </Form.Group>
                                                </div>
                                                {this.countDom("d-md-none")}
                                            </div>
                                            <div className="header-right d-flex align-items-center justify-content-between gap-8">
                                                {this.includeArchiveDom()}
                                                <div className='d-flex align-items-center justify-content-between gap-8'>
                                                    {Object.keys(this.state.archiveItems).length ?
                                                        <Button onClick={this.addArchive} className='archive'
                                                            disabled={this.state.addArchiveStatus === "REQUEST"}>
                                                            Archive
                                                        </Button> : null}
                                                    {this.countDom("d-none d-md-block")}
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                            }
                            {
                                this.state.filterLoading ? <div className={`loader d-flex align-items-center justify-content-center ${this.state.filterLoading ? 'loader-h-v' : 'h-100'}`}>
                                    <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                                </div> :
                                    <Row xs={1}>
                                        {
                                            this.state.itemsList.map((item, index) =>
                                                <Col key={`items_${index}`}>
                                                    <div className="content-container d-flex clickable" onClick={() => this.itemViewScreen(item, index)}>
                                                        <div className="left-side d-none d-md-flex align-items-center justify-content-center">
                                                            <img className="location-image" src={ item.thumbnailurl ? item.thumbnailurl : item.displayimageurl ? item.displayimageurl : image_thumbnail } alt="item-image"></img>
                                                        </div>
                                                        <div className={`right-side ${this.page === "won" ? '' : ''}`}>
                                                            <div className={`d-md-flex align-items-center justify-content-between header`}>
                                                                <div className="d-flex align-items-center">
                                                                    {/* <div className="more-on">More on Store</div> */}
                                                                    Sale - {item.saletitle}
                                                                </div>
                                                                <div className='d-flex align-items-center header-action justify-content-md-end'>
                                                                    <div className="mr-12">Location - {item.locationtitle}</div>
                                                                    <div className="more-on clickable" onClick={(event) => this.getBidHistory(event, item)}>Bid History</div>
                                                                    {this.state.itemsArchived[item.id] ?
                                                                        <div>Archived</div>
                                                                        :
                                                                        <div id="archive-item" className="d-flex align-items-center clickable h-100"
                                                                            onClick={(event) => this.toggleArchiveItems(event, item.id)}
                                                                        >
                                                                            <Form.Check
                                                                                custom
                                                                                type="checkbox"
                                                                                id={`archive-item-${item.id}`}
                                                                                label='Archive'
                                                                                className="clickable"
                                                                                aria-label='archive'
                                                                                checked={this.state.archiveItems[item.id]}
                                                                            />
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="details d-flex flex-column align-items-start justify-content-between">
                                                                <div className="w-100">
                                                                    <div className="d-flex d-md-none align-items-center justify-content-center location-image-con">
                                                                        <img className="location-image-mobile" src={item.displayimageurl ? item.displayimageurl : image_thumbnail} alt="location-image"></img>
                                                                    </div>
                                                                    <Row>
                                                                        <Col lg={5}>
                                                                            <div className="title h5 text-bold">
                                                                                {item.title}
                                                                            </div>
                                                                        </Col>
                                                                        <Col lg={7}>
                                                                            <div className="d-md-flex align-items-center justify-content-evenly">
                                                                                {
                                                                                    this.page === 'not-won' ?
                                                                                        <div className="w-20">
                                                                                            <div>My Bid</div>
                                                                                            <div className="second-text">{this.getBidPrice(item)}</div>
                                                                                        </div> : null
                                                                                }
                                                                                <div className="w-20">
                                                                                    <div>{this.page === 'won' ? 'Sale' : 'Final'} Price</div>
                                                                                    <div className="second-text">{this.getFinalPrice(item)}</div>
                                                                                </div>
                                                                                <div className="w-25">
                                                                                    <div>Sale on</div>
                                                                                    <div className="second-text">{this.getDateAndTime(item, 'Date')}</div>
                                                                                </div>
                                                                                <div className="w-25">
                                                                                    <div>Sale time</div>
                                                                                    <div className="second-text">{this.getDateAndTime(item, 'Time')}</div>
                                                                                </div>
                                                                                <div className="w-10">
                                                                                    <div>Zip Code</div>
                                                                                    <div className="second-text">{item.zipcode}</div>
                                                                                </div>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                                <hr className="hr-line"></hr>

                                                                <div className="d-flex align-items-center justify-content-between w-100 mx-r-5">
                                                                    <div>
                                                                        <div>
                                                                            <Button variant="secondary" onClick={(event) => this.locationScreen(event, item)}>Contact seller</Button>
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        this.page === 'not-won' && this.getFinalPrice(item) === '---' &&
                                                                         item.soldprice < item.reserveprice && item.soldprice > 0  && item.reserveprice > 0 ?
                                                                            <div>
                                                                                <div className="text-danger">
                                                                                    Reserve Price not Met
                                                                                </div>
                                                                            </div> : null
                                                                    }
                                                                    <div>
                                                                        <div className="arrow-right clickable" onClick={() => this.itemViewScreen(item, index)}>
                                                                            <i className="fas fa-long-arrow-alt-right"></i>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            )
                                        }
                                    </Row>
                            }
                            {
                                this.state.nextList && !this.state.filterLoading && !this.props.getNextItem ?
                                    <div className="d-flex align-items-center browse-all-main justify-content-center">
                                        <div className={`browse-all clickable ${this.state.nextList ? '' : 'custom-disable'} ${this.state.loaderForMore ? 'custom-disable' : ''}`} onClick={this.getMoreList}>
                                            More {this.state.loaderForMore ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                                        </div>
                                    </div> : null
                            }
                        </div>
                }
                <Modal centered show={this.state.bidHistoryModal} animation={false} size="lg" onHide={this.bidHistoryModalToggle}>
                    <Modal.Header>
                        <div type="button" onClick={() => this.bidHistoryModalToggle()} className="close" data-dismiss="modal" variant="outline-primary" aria-label="Close"><span aria-hidden="true">&times;</span></div>
                    </Modal.Header>
                    <Modal.Body className="d-flex flex-column align-items-center justify-content-center table-modal-body">
                        <div className="modal-table">
                            <Table hover>
                                <thead>
                                    <tr>
                                        <th>Bidders</th>
                                        <th>Bid Date</th>
                                        <th>Bid Time</th>
                                        <th>Bid Amount</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.bidHistory.length === 0 ?
                                            <tr>
                                                {
                                                    this.state.bidLoading ?
                                                        <td colSpan="5" className="text-center">
                                                            <div className="loader d-flex align-items-center justify-content-center h-100">
                                                                <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                                                            </div>
                                                        </td> :
                                                        <td colSpan="5" className="text-center">No Data Found</td>

                                                }
                                            </tr> :
                                            this.state.bidHistory.map((bidding, index) =>
                                                <tr key={`bid_history_${index}`}>
                                                    <td>{bidding.nickname}</td>
                                                    <td>{dateTimeFormat(bidding.createddate)}</td>
                                                    <td>{dateTimeFormat(bidding.createddate, true)}</td>
                                                    <td>${bidding.bidprice}</td>
                                                    <td>{bidding.biddingstatus}</td>
                                                </tr>
                                            )
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </Modal.Body>
                </Modal>
            </div >
        );
    }
}